import { useCallback, useState } from "react";

export const useEmailInput = () => {
    const [email, setEmail] = useState("");
    const [touched, setTouched] = useState(false);

    const isValidEmail = (email: string): boolean =>
        /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

    const handleEmailChange = useCallback((value: string) => {
        setEmail(value);
        setTouched(true);
    }, []);

    const isEmailValid = isValidEmail(email);
    const showEmailError = touched && !isEmailValid;

    return {
        email,
        setEmail: handleEmailChange,
        isEmailValid,
        showEmailError,
    };
};
